import { actionTypes } from '../constants/actionTypes';

const skillsFinderDefault = {
  loaded: false,
  data: []
};

export const overviewHistoryReceived = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.OVERVIEW_HISTORY_RECEIVED:
      return Object.assign({}, state, action.payload);
  }
  return state;
};

export const overviewHistorySent = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.OVERVIEW_HISTORY_SENT:
      return Object.assign({}, state, action.payload);
  }
  return state;
};

export const overviewBankSummary = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.OVERVIEW_BANK_SUMMARY:
      return Object.assign({}, state, action.payload);
  }
  return state;
};


export const overviewRecentOrders = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.OVERVIEW_RECENT_ORDERS:
      return Object.assign({}, state, action.payload);
  }
  return state;
};

export const overviewSkillsFinder = (state = skillsFinderDefault, action) => {
  switch (action.type) {
    case actionTypes.OVERVIEW_SKILLS_FINDER:
      return Object.assign({}, state, action.payload);
  }
  return state;
};

export const overviewAlerts = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.OVERVIEW_ALERTS:
      return Object.assign({}, state, action.payload);
  }
  return state;
};

export const isDisplayReceivedActions = (state = false, action) => {
  switch (action.type) {
    case actionTypes.IS_DISPLAY_RECEIVED_ACTIONS:
      return action.payload;
  }
  return state;
};

export const isDisplayeCardDialogActions = (state = false, action) => {
  switch (action.type) {
    case actionTypes.IS_DISPLAY_ECARD_DIALOG_ACTIONS:
      return action.payload;
  }

  return state;
};

export const isDisplayNominationDialogActions = (state = false, action) => {
  switch (action.type) {
    case actionTypes.IS_DISPLAY_NOMINATION_DIALOG_ACTIONS:
      return action.payload;
  }

  return state;
};

export const nominationActivityValues = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.NOMINATION_ACTIVITY_VALUES:
      return Object.assign({}, state, action.payload);
  }

  return state;
};

export const ecardActivityValues = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.ECARD_ACTIVITY_VALUES:
      return Object.assign({}, state, action.payload);
  }

  return state;
};

export const isDisplayAlertsSection = (state = false, action) => {
  switch (action.type) {
    case actionTypes.IS_DISPLAY_ALERTS_SECTION:
      return action.payload;
  }

  return state;
};

export const isDisplaySkillsSection = (state = true, action) => {
  switch (action.type) {
    case actionTypes.IS_DISPLAY_SKILLS_SECTION:
      return action.payload;
  }

  return state;
};

export const isDisplayRedeemLink = (state = false, action) => {
  switch (action.type) {
    case actionTypes.IS_DISPLAY_REDEEM_LINK:
      return action.payload;
  }

  return state;
};

export const isDisplaySkillsLoader = (state = true, action) => {
  switch (action.type) {
    case actionTypes.IS_DISPLAY_SKILLS_LOADER:
      return action.payload;
  }

  return state;
};

export const isDisplayAwardPoints = (state = false, action) => {
  switch (action.type) {
    case actionTypes.IS_DISPLAY_AWARD_POINTS:
      return action.payload;
  }

  return state;
};

export const isDisplayReplyLink = (state = false, action) => {
  switch (action.type) {
    case actionTypes.IS_DISPLAY_REPLY_LINK:
      return action.payload;
  }

  return state;
};

export const isDisplayOrdersSection = (state = true, action) => {
  switch (action.type) {
    case actionTypes.IS_DISPLAY_ORDERS_SECTION:
      return action.payload;
  }

  return state;
};

export const isDisplayBanksSection = (state = true, action) => {
  switch (action.type) {
    case actionTypes.IS_DISPLAY_BANKS_SECTION:
      return action.payload;
  }

  return state;
};
